import { Context, FormContext } from "../../../forms";
import React, { useEffect } from "react";
import { TimerProps, iTimer, iTimerEvents } from "./types";

import DigitalClock from "./timer-clock";
import Timer from "./timer";
import TimerControls from "./timer-controls";

/**
 * Form updates
 */
const createUpdateEvent = (form: FormContext, name: string) => (
    timer: iTimer
) => {
    form.setValue(name, timer);
};

/**
 * Timer Events
 */
const createTimerEvents = (form: FormContext, name: string): iTimerEvents => ({
    onStart: createUpdateEvent(form, name),
    onTick: createUpdateEvent(form, name),
    onStop: createUpdateEvent(form, name),
    onReset: createUpdateEvent(form, name)
});

/**
 * Auto start timer
 * @param timer
 * @param value
 * @returns
 */
const initEffect = (props: TimerProps, timer: iTimer) => () => {
    !props.value && props.autoStart && timer.start();
};

/**
 * Timer Field
 * @param props
 * @returns
 */
const TimerField = (props: TimerProps) => {
    const form = React.useContext(Context) as FormContext;
    const name = props.timerName || props.name;
    const timer = props.value || new Timer(createTimerEvents(form, name));

    useEffect(initEffect(props, timer), []);

    return render(timer);
};

/**
 * Render function
 * @param timer
 * @returns
 */
const render = (timer: iTimer) => (
    <div>
        <DigitalClock timer={timer} />
        <TimerControls timer={timer} />
    </div>
);

export default TimerField;
